import '../../external/jquery.ui.touch-punch.min';

export const VEHICLE_PRICE_PREFERENCE = {
    LEAST_EFFORT: '0',
    BOTH_EQUAL: '1',
    BEST_PRICE: '2',
};

export const sellVehiclePriceSlider = {
    sliderName: '',
    valueElement: '',
    init(optionsInput) {
        const options = optionsInput || {};
        this.sliderName = options.sliderName ? options.sliderName : $('#priceSlider');
        this.valueElement = options.valueElement ? options.valueElement : $('#priceValue');

        // Initialize the slider with three values
        this.sliderName.slider({
            animate: true,
            range: 'min', // Single handle slider
            min: 0, // Three possible values: 0, 1, 2
            max: 2,
            step: 1, // Slider only snaps to 0, 1, or 2
            create() {
                // Set the slider to the initial value
                sellVehiclePriceSlider.setSlider(0); // Default to "With the least effort"
            },
            slide(event, ui) {
                // Update the value and label dynamically
                sellVehiclePriceSlider.valueElement.val(ui.value);
            },
            stop() {
                sellVehiclePriceSlider.valueElement.trigger('change');
            },
        });

        // Add click events to labels
        this.addLabelClickEvents();

        // Add click event for slider track
        this.addTrackClickEvent();
    },
    setSlider(value) {
        this.sliderName.slider('value', value);
        this.valueElement.val(value);
    },
    addLabelClickEvents() {
        // Add click event listeners to each label
        $('#labelWithLeastEffort').click(() => {
            this.setSlider(0);
        });
        $('#labelNeutral').click(() => {
            this.setSlider(1);
        });
        $('#priceRange').click(() => {
            this.setSlider(2);
        });
    },
    addTrackClickEvent() {
        // Add click event listener for the slider track
        this.sliderName.parent().on('click', (event) => {
            // Check if the click is not on the handle
            if (!$(event.target).hasClass('ui-slider-handle')) {
                const sliderOffset = this.sliderName.offset();
                const sliderWidth = this.sliderName.width();
                const clickPosition = event.pageX - sliderOffset.left;

                // Calculate the new slider value based on click position
                const newValue = Math.round((clickPosition / sliderWidth) * 2);

                // Set the slider to the new value
                this.setSlider(newValue);
            }
        });
    },
};
